import * as Yup from "yup";

const validator = {
  email: Yup.string().email().required("Please Enter Your email"),
  old_password: Yup.string().required("Please Enter Your password"),
  password: Yup.string()
    .required("Please Enter Your password")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase,One Number and one special case"
    ),
  new_password: Yup.string()
    .required("Please Enter Your password")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase,One Number and one special case"
    ),
  confirm_password: Yup.string()
    .required("Confirm Password")
    .oneOf(
      [Yup.ref("password"), Yup.ref("new_password"), null],
      "Password did not match"
    ),
  otp: Yup.number().positive().integer().required("Please Enter OTP"),
  first_name: Yup.string().required("Please Enter Your First Name"),
  last_name: Yup.string().required("Please Enter Your Last Name"),
  phone_number: Yup.string().required("Please Enter Your Phone Number"),
  address: Yup.string().max(500).required("Please Enter Your Address"),
  gender: Yup.string().required("Gender is required"),
  profile_image: Yup.mixed()
    // .required("Please upload a profile image")
    .test("fileType", "Only image files are allowed", (value) => {
      // console.log("img", value);
      if (value === undefined || typeof value !== "object") {
        return true; // No file is fine, since it's marked as required separately
      }
      return (
        value && ["image/jpeg", "image/png", "image/gif"].includes(value.type)
      );
    })
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value || typeof value !== "object") {
        return true; // No file is fine, since it's marked as required separately
      }
      return value.size <= 5 * 1024 * 1024; // 5MB
    }),
  manager: Yup.number().required("Please Select Your manager"),
  department: Yup.number().required("Please Select Your department"),
  designation: Yup.number().required("Please Select Your designation"),
  user_type: Yup.string().required("Please Select Your user_type"),
  branch: Yup.number().required("Please Select Your branch"),
  // week_off: Yup.number().required("Please Select Week off"),
};

export const generateYupSchema = (fieldList) => {
  // console.log(fieldList);
  const yupSchema = {};

  Object.keys(fieldList).forEach((fieldName) => {
    if (validator[fieldName]) {
      yupSchema[fieldName] = validator[fieldName];
    }
  });

 


 
// const inferYupType = (value, fieldName) => {
//   if (Array.isArray(value)) {
//     return Yup.array()
//       .of(Yup.string().required(`${fieldName} cannot be empty`))
//       .min(1, `${fieldName} must have at least one item`)
//       .required(`${fieldName} is required`);
//   } else if (typeof value === 'number') {
//     return Yup.number()
//       .typeError(`${fieldName} must be a number`)
//       .required(`${fieldName} is required`);
//   } else if (typeof value === 'boolean') {
//     return Yup.boolean().required(`${fieldName} is required`);
//   } else {
//     return Yup.string().required(`${fieldName} is required`);
//   }
// };
 
 
// export const generateDynamicValidationSchema = (initialValues) => {
//   const shape = Object.keys(initialValues).reduce((schema, key) => {
//     const value = initialValues[key];
//     schema[key] = inferYupType(value, key);
//     return schema;
//   }, {});
 
//   return Yup.object().shape(shape);
// };

  return Yup.object(yupSchema);
};

export const loginSchema = Yup.object({
  email: validator.email,
  password: validator.password,
});
export const forgetPasswordSchema = Yup.object({
  email: validator.email,
});
export const OTPSchema = Yup.object({
  otp: validator.otp,
});
export const changePasswordSchema = Yup.object({
  password: validator.password,
  confirm_password: validator.confirm_password,
});
export const addUserSchema = Yup.object({
  email: validator.email,
  first_name: validator.first_name,
  last_name: validator.last_name,
  phone_number: validator.phone_number,
  address: validator.address,
  gender: validator.gender,
  profile_image: validator.profile_image,
  manager: validator.manager,
  department: validator.department,
  designation: validator.designation,
  user_type: validator.user_type,
  branch: validator.branch,
  password: validator.password,
  confirm_password: validator.confirm_password,
});
export const upadateUserSchema = Yup.object({
  email: validator.email,
  first_name: validator.first_name,
  last_name: validator.last_name,
  phone_number: validator.phone_number,
  address: validator.address,
  gender: validator.gender,
  profile_image: validator.profile_image,
  manager: validator.manager,
  department: validator.department,
  designation: validator.designation,
  user_type: validator.user_type,
  branch: validator.branch,
});

// Delivery form validation <schema></schema>
export const deliverySchema = Yup.object({
  name: Yup.string().required("Business Type Name is required"),
  default_image: Yup.mixed().required("Please upload an image"),
  description: Yup.string().required("Description is required"),
  // sequence_number: Yup.number()
  //   .positive("Sequence number must be positive")
  //   .required("Sequence number is required"),
  // delivery_type: Yup.string().required("Delivery Type is required"),
  
});

